
export {DataProvider,
FetchPolicy,
NetworkStatus,
useResource} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$data-provider.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$data-provider.js';export default __x__;